import api from "./api";

export const ASSIGNMENT_TEACHER_PAGE_SIZE = 25;
export const ASSIGNMENT_TEACHER_STATUSES = ["all", "assigned", "unassigned"];

const value = (source, ...keys) => keys.map((key) => source?.[key]).find((item) => item != null);

function authHeaders() {
  const token = localStorage.getItem("tk446655440000");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function buildAssignmentTeacherParams({
  pageNumber = 1,
  pageSize = ASSIGNMENT_TEACHER_PAGE_SIZE,
  search = "",
  assignmentStatus = "all",
} = {}) {
  const normalizedAssignmentStatus = String(assignmentStatus ?? "").toLowerCase();
  const params = {
    pageNumber: Math.max(1, Number(pageNumber) || 1),
    pageSize: Math.min(100, Math.max(1, Number(pageSize) || ASSIGNMENT_TEACHER_PAGE_SIZE)),
    assignmentStatus: ASSIGNMENT_TEACHER_STATUSES.includes(normalizedAssignmentStatus)
      ? normalizedAssignmentStatus
      : "all",
  };
  const normalizedSearch = String(search ?? "").trim();
  if (normalizedSearch) params.search = normalizedSearch;
  return params;
}

export function toAssignmentTeacherOption(item) {
  const firstName = value(item, "name", "firstName", "Name") || "";
  const lastName = value(item, "preName", "lastName", "PreName") || "";
  const teacherName =
    [firstName, lastName].filter(Boolean).join(" ") ||
    value(item, "teacher", "fullName", "FullName") ||
    "";
  const regNumber = value(item, "regNumber", "RegNumber") || "";
  const phone = value(item, "phone", "Phone", "phoneNumber", "PhoneNumber") || "";
  const currentEstablishmentName = value(
    item,
    "currentEstablishmentName",
    "CurrentEstablishmentName",
    "establishmentName",
    "EstablishmentName",
    "estName",
    "EstName"
  );
  const teacherLabel = [regNumber, teacherName, phone].filter(Boolean).join(" - ");

  return {
    id: value(item, "id", "Id"),
    text: currentEstablishmentName
      ? `${teacherLabel} — ${currentEstablishmentName}`
      : teacherLabel,
    name: firstName,
    preName: lastName,
    regNumber,
    currentEstablishmentId: value(
      item,
      "currentEstablishmentId",
      "CurrentEstablishmentId",
      "establishmentId",
      "EstablishmentId",
      "estabId",
      "EstabId"
    ),
    currentEstablishmentName,
  };
}

export function parseAssignmentTeacherPage(data, requestedPage = 1, requestedPageSize = 25) {
  const items = value(data, "items", "Items") || (Array.isArray(data) ? data : []);
  const pagination = value(data, "pagination", "Pagination") || {};
  const pageNumber = Number(value(pagination, "pageNumber", "PageNumber") ?? requestedPage);
  const pageSize = Number(value(pagination, "pageSize", "PageSize") ?? requestedPageSize);
  const totalRecords = Number(value(pagination, "totalRecords", "TotalRecords") ?? items.length);
  const totalPages = Number(
    value(pagination, "totalPages", "TotalPages") ?? Math.max(1, Math.ceil(totalRecords / pageSize))
  );

  return {
    items: (Array.isArray(items) ? items : []).map(toAssignmentTeacherOption).filter((item) => item.id != null),
    pagination: {
      pageNumber,
      pageSize,
      totalRecords,
      totalPages,
      hasNextPage: Boolean(
        value(pagination, "hasNextPage", "HasNextPage") ?? pageNumber < totalPages
      ),
    },
  };
}

export async function fetchAssignmentTeachers({
  pageNumber,
  pageSize,
  search,
  assignmentStatus,
  signal,
} = {}) {
  const params = buildAssignmentTeacherParams({ pageNumber, pageSize, search, assignmentStatus });
  const { data } = await api.get("/Assignment/teachers", {
    params,
    headers: authHeaders(),
    signal,
  });
  return parseAssignmentTeacherPage(data, params.pageNumber, params.pageSize);
}
